export default __webpack_public_path__ + "static/media/text.7c16b180.svg";